import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { AnimatePresence, m } from "framer-motion";
import { trackCta } from "../../utils/tracking";
import { IOS_LIVE, detectPlatform } from "../../config/stores";
import GetAppLink from "../ui/GetAppLink";

// Phones only: once the hero is behind you, the two ways in stay one tap away.
// Hidden on the waitlist page (the form is the page) and while the footer is visible.
export default function MobileCtaBar() {
    const { pathname } = useLocation();
    const [visible, setVisible] = useState(false);
    const waitlistOnly = detectPlatform() === "ios" && !IOS_LIVE;

    useEffect(() => {
        const onScroll = () => {
            const footer = document.querySelector("footer");
            const nearFooter = footer ? footer.getBoundingClientRect().top < window.innerHeight - 40 : false;
            setVisible(window.scrollY > 640 && !nearFooter);
        };
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        window.addEventListener("resize", onScroll);
        return () => {
            window.removeEventListener("scroll", onScroll);
            window.removeEventListener("resize", onScroll);
        };
    }, [pathname]);

    if (pathname.startsWith("/waitlist")) return null;

    return (
        <AnimatePresence>
            {visible ? (
                <m.div
                    initial={{ y: 90, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: 90, opacity: 0 }}
                    transition={{ type: "spring", stiffness: 420, damping: 36 }}
                    className="fixed inset-x-3 bottom-3 z-header lg:hidden"
                    style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
                >
                    <div className="glass flex items-center gap-2 rounded-xl p-2">
                        {/* One button, the right one for this phone. */}
                        {waitlistOnly ? (
                            <Link
                                to="/waitlist?platform=ios"
                                onClick={() => trackCta("mobile_bar", { cta_label: "ios_waitlist" })}
                                className="btn btn-md btn-primary flex-1"
                            >
                                Join the iPhone waitlist
                            </Link>
                        ) : (
                            <GetAppLink placement="mobile_bar" className="btn btn-md btn-primary flex-1">
                                Get the app
                            </GetAppLink>
                        )}
                    </div>
                </m.div>
            ) : null}
        </AnimatePresence>
    );
}
